import { useGetCommentReplies } from '@/api';
import type { IReaction } from '@/api';
import { useAuthContext } from '@/contexts/auth';
import { CommentInput } from '@/features/comments/components/CommentInput';
import { ReplyItem } from '@/features/comments/components/ReplyItem';
import { useCommentReplies } from '@/features/comments/hooks/useComment';
import type { ReplySectionProps } from '@/features/comments/types';

export const ReplySection = ({
	isReplying,
	onReply,
	onLike,
	onReplyToComment,
	commentId,
}: ReplySectionProps) => {
	const {
		items: replies,
		isLoading,
		hasMore,
		loadMoreRef,
	} = useCommentReplies(useGetCommentReplies, commentId);

	const { user } = useAuthContext();

	const handleLike = (data: IReaction) => {
		onLike(commentId, data);
	};

	const handleReply = (content: string, isReplyOfReply = false) => {
		onReplyToComment(commentId);
		onReply(content, isReplyOfReply);
	};

	if (isLoading) {
		return <div>Loading replies...</div>;
	}

	return (
		<>
			{isReplying && (
				<div className="mt-3">
					<CommentInput
						onSubmit={onReply}
						placeholder="Write a reply..."
						author={{
							userId: user?.userId ?? '',
							userFullName: user?.fullName ?? '',
							userAvatar: user?.avatar ?? '/images/user.png',
						}}
					/>
				</div>
			)}

			{replies.length > 0 && (
				<div className="mt-3 space-y-4">
					{replies.map((reply) => (
						<ReplyItem
							key={reply.id}
							reply={reply}
							onLike={handleLike}
							onReply={handleReply}
						/>
					))}
				</div>
			)}
			{hasMore && <div ref={loadMoreRef}>Loading more...</div>}
		</>
	);
};
